import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  // 当点击或者聚焦时触发
  fillCurrentTime(event) {
    const input = event.target
    
    // 只有当输入框为空时才自动填入
    if (!input.value) {
      const now = new Date()
      
      // 格式化为 YYYY-MM-DDTHH:mm (datetime-local 控件要求的格式)
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      
      const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`
      
      input.value = formattedDateTime
      
      // 触发 change 事件以便其他监听器感应到变化
      input.dispatchEvent(new Event('change'))
    }
  }
}
